import axios from 'axios';
import type {
  ContactType,
  IContact,
  IContactCreateRequest,
  IContactCreateResponse,
  IContactOwner,
} from '@bb/contacts';

import type { ContactPayload } from './types';

const createContactWithOwner = async <T extends IContact>(
  type: ContactType,
  payload: ContactPayload<T> & { owner: IContactOwner },
) => {
  const config: IContactCreateRequest = {
    url: '/contacts/with_owner',
    data: {
      ...payload,
      type,
    },
    method: 'post',
  };

  const { data } = await axios.request<IContactCreateResponse>(config);

  return data;
};

export default createContactWithOwner;
